"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiplev2Addenda = void 0;
// @ts-nocheck
exports.multiplev2Addenda = {
    id: 20981,
    caseRuns: [
        {
            version: null,
            case_json_id: null,
            case_id: 20981,
            process_instance_id: 24056,
            process_instance_guid: "8a79ba18-68ba-4cba-9a85-65bd8603c657",
            case_encounter_id: 15633,
            case_status: "Automated",
            process_status: "Done",
            primary_process_indicator: true,
            run_type: "prediction",
            source_type: "HL7",
            service_line: "Radiology",
            tenant_code: "MGH",
            tenant_name: "Massachusetts General Hospital",
            tenant_timezone: "America/New_York",
            health_system_code: "PHS",
            service_tenant_name: null,
            service_tenant_code: null,
            provider_tenant_name: null,
            provider_tenant_code: null,
            patient_id: 212060,
            patient_name: "SCENARIO14, JESSICA",
            date_of_birth: "1981-08-18",
            patient_age: null,
            patient_gender: "F",
            patient_identifier: {
                number: "8fdead1fe7bd4df7876eaeb4423e0860",
                issuer: "EPIC",
                type: "PMRN"
            },
            visit_number: {
                number: "VISIT-ad678d14026c4f8b8aa77986c69314cf",
                issuer: "EPIC",
                type: "VISIT_NUMBER"
            },
            account_number: {
                number: "6122578737",
                issuer: null,
                type: null
            },
            patient_class: "OUTPATIENT",
            patient_type: null,
            reason_for_visit: "*Ankle pain, osteochondral lesion suspected, neg xray",
            primary_insurance: null,
            primary_insurance_category: null,
            encounter_identifier: {
                number: "VISIT-ad678d14026c4f8b8aa77986c69314cf-2022-04-27-261142",
                issuer: "CMX",
                type: "ENCOUNTER_NUMBER"
            },
            point_of_care: "MGH_IMGMRNS",
            place_of_service: null,
            order_control: "RE",
            order_number: {
                number: "RAD_PHS_CBR_001-6ab86f7da2284a6eb1a2857930115457",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_placer_number: {
                number: "RAD_PHS_CBR_001-6ab86f7da2284a6eb1a2857930115457",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_filler_number: {
                number: "Eef081057a95e43debb69ad7897ef060e",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            ordering_provider_name: "CHIODO, CHRISTOPHER",
            ordering_provider_specialty: "",
            ordering_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            primary_clinical_identifier: {
                number: "Eef081057a95e43debb69ad7897ef060e",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            division: "MGDAN",
            exam_code: "MR.MS.ANK-/R",
            exam_description: "MRI ANKLE WITHOUT CONTRAST (RIGHT)",
            body_region: "Lower Extremity",
            procedure_type: "Magnetic Resonance",
            procedure_type_category: "MR",
            work_queue_name: "MR UPPER/LOWER EXT JOINT",
            date_of_service: "2022-04-27",
            datetime_of_service: "2022-04-27 11:43:14 EDT",
            exam_date: null,
            exam_datetime: null,
            relevant_clinical_info: null,
            sending_facility: "ICMPB RADMGH",
            placer_field_2: null,
            patient_primary_facility: null,
            service: null,
            transaction_id: null,
            result_status: "F",
            scheduling_department: "MGH IMG MR NS",
            scheduling_department_code: "MGH_IMGMRNS",
            resource_name: "MGH MR1NS",
            resource_code: "MR1NS",
            admission_datetime: null,
            discharge_datetime: null,
            attending_provider_specialty: null,
            attending_provider_name: null,
            attending_provider_number: null,
            billing_location: "MGDAN",
            billing_area: null,
            billing_provider_specialty: "",
            billing_provider_name: "ROSENTHAL, DANIEL",
            billing_provider_number: {
                number: "12177",
                issuer: "NWH",
                type: "PRN"
            },
            billing_provider_assistant_name: null,
            billing_provider_assistant_number: null,
            billing_patient_identifier: null,
            referring_provider_specialty: null,
            referring_provider_name: "CHIODO, CHRISTOPHER",
            referring_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            performing_provider_specialty: null,
            performing_provider_name: null,
            performing_provider_number: null,
            service_provider_specialty: null,
            service_provider_name: null,
            service_provider_number: null,
            hl7_insurance_plan_id: null,
            hl7_insurance_plan_text: null,
            hl7_insurance_payer_id: null,
            hl7_insurance_payer_name: null,
            hl7_insurance_plan_type: null,
            tenant_insurance_plan_id: null,
            tenant_insurance_plan_text: null,
            tenant_insurance_payer_id: null,
            tenant_insurance_payer_name: null,
            tenant_insurance_payer_number: null,
            tenant_medicare_contractor: null,
            cmx_insurance_plan_text: "UNKNOWN PAYER (System Applied)",
            cmx_insurance_payer_id: "172",
            cmx_mapped_payer_number: null,
            cmx_payer_group_name_property_name: null,
            cmx_payer_category_property_name: null,
            claims_edit_enabled_indicator: null,
            medicare_jurisdiction: null,
            medicare_contractor: null,
            requires_medicaid_cci_edits_indicator: false,
            requires_cms_cci_edits_indicator: false,
            requires_ncd_edits_indicator: false,
            requires_lcd_edits_indicator: false,
            requires_commercial_edits_indicator: false,
            requires_mln_edits_indicator: false,
            requires_article_edits_indicator: false,
            requires_cms_manual_edits_indicator: false,
            requires_transmittal_manual_edits_indicator: false,
            specimen_sources: [],
            scenario: null,
            scenarios: [],
            case_type: null,
            specialty: null,
            grouper: null,
            custom_values: {
                routing: "MR1NS"
            },
            mappings: [
                {
                    name: "exam_code",
                    value: "MR.MS.ANK-/R",
                    mapped_values: [
                        {
                            name: "work_queue_name",
                            value: "MR UPPER/LOWER EXT JOINT",
                            values: []
                        },
                        {
                            name: "procedure_type",
                            value: "Magnetic Resonance",
                            values: []
                        },
                        {
                            name: "procedure_type_category",
                            value: "MR",
                            values: []
                        }
                    ]
                }
            ],
            invoices: [],
            artifacts: [
                {
                    artifact_id: 98528,
                    type: "PREDICTION",
                    identifier: "24056",
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115023,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: 0.95,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 1.4904447586516767e-4,
                                        feature: {
                                            slop: 0,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "ankl without",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 1.4904447586516767e-4,
                                        feature: {
                                            slop: 1,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "ankl without",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 1.4904447586516767e-4,
                                        feature: {
                                            slop: 0,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "mri ankl",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 1.4904447586516767e-4,
                                        feature: {
                                            slop: 1,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "mri ankl",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 1.4904447586516767e-4,
                                        feature: {
                                            slop: 1,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "mri without",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true,
                                modifiers: {
                                    confidence: 0.0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: 0.95
                    },
                    modifiers: {
                        confidence: 0.0,
                        automate: true,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.5,
                        primary_code_confidence: 0.46,
                        primary_predicted_code: "M25.571",
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_uid: null,
                                diagnosis_code: "M25.571",
                                evidence_source_uid: null,
                                automate: false,
                                confidence: 0.5,
                                sequence_number: null,
                                type: null,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 0.0968649187900067,
                                        feature: {
                                            slop: 0,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "ankl",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.05942308073958924,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "pain",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.05942308073958924,
                                        feature: {
                                            slop: 2,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "ankl pain",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.05942308073958924,
                                        feature: {
                                            slop: 0,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "ankl",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.05942308073958924,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "pain",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.04989967417015073,
                                        feature: {
                                            slop: 1,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "without right",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.017257403860321263,
                                        feature: {
                                            category: "Lower Extremity",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.017257403860321263,
                                        feature: {
                                            slop: 2,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "ankl right",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            }
                        ]
                    }
                },
                {
                    artifact_id: 98525,
                    type: "MAPPED",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115020,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: -1.0,
                                    automate: false,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            modifier_uid: null,
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: -1.0,
                                            sequence_number: 1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 98533,
                    type: "PROCESSED",
                    identifier: "24056",
                    procedures: {
                        automate: true,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115028,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: true,
                                confidence: 1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: 0.0,
                                    automate: true,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            modifier_uid: null,
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: -1.0,
                                            sequence_number: 1,
                                            evidence: [],
                                            used: true
                                        },
                                        {
                                            modifier_code: "ACT",
                                            modifier_uid: null,
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: 1.0,
                                            sequence_number: 2,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0.5,
                                    primary_code_confidence: -1.0,
                                    primary_predicted_code: null,
                                    automate: true,
                                    type: null,
                                    evidence: [],
                                    codes: [
                                        {
                                            diagnosis_uid: null,
                                            diagnosis_code: "M25.571",
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: 0.5,
                                            sequence_number: 1,
                                            type: null,
                                            evidence: [
                                                {
                                                    type: "Ngram",
                                                    score: 0.0968649187900067,
                                                    feature: {
                                                        slop: 0,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "ankl",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "pain",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 2,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "ankl pain",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 0,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "ankl",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "pain",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.04989967417015073,
                                                    feature: {
                                                        slop: 1,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "without right",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Categorical",
                                                    score: 0.017257403860321263,
                                                    feature: {
                                                        category: "Lower Extremity",
                                                        field: "body_region",
                                                        type: "categorical"
                                                    },
                                                    type: "Categorical"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.017257403860321263,
                                                    feature: {
                                                        slop: 2,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "ankl right",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                }
                                            ],
                                            used: true
                                        }
                                    ]
                                }
                            }
                        ],
                        confidence: 1.0
                    },
                    modifiers: {
                        confidence: 0.0,
                        automate: true,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.5,
                        primary_code_confidence: 0.46,
                        primary_predicted_code: "M25.571",
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 98526,
                    type: "CLINICAL",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115021,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: 0.0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 98532,
                    type: "ASSEMBLED",
                    identifier: "24056",
                    procedures: {
                        automate: true,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115027,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: true,
                                confidence: 1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: 0.0,
                                    automate: true,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            modifier_uid: null,
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: -1.0,
                                            sequence_number: 1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0.5,
                                    primary_code_confidence: -1.0,
                                    primary_predicted_code: null,
                                    automate: true,
                                    type: null,
                                    evidence: [],
                                    codes: [
                                        {
                                            diagnosis_uid: null,
                                            diagnosis_code: "M25.571",
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: 0.5,
                                            sequence_number: 1,
                                            type: null,
                                            evidence: [
                                                {
                                                    type: "Ngram",
                                                    score: 0.0968649187900067,
                                                    feature: {
                                                        slop: 0,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "ankl",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "pain",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 2,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "ankl pain",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 0,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "ankl",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.05942308073958924,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "pain",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.04989967417015073,
                                                    feature: {
                                                        slop: 1,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "without right",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Categorical",
                                                    score: 0.017257403860321263,
                                                    feature: {
                                                        category: "Lower Extremity",
                                                        field: "body_region",
                                                        type: "categorical"
                                                    },
                                                    type: "Categorical"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.017257403860321263,
                                                    feature: {
                                                        slop: 2,
                                                        field: "exam_type",
                                                        in_order: true,
                                                        ngram: "ankl right",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                }
                                            ],
                                            used: true
                                        }
                                    ]
                                }
                            }
                        ],
                        confidence: 1.0
                    },
                    modifiers: {
                        confidence: 0.0,
                        automate: true,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.5,
                        primary_code_confidence: 0.46,
                        primary_predicted_code: "M25.571",
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                }
            ],
            transactions: [],
            notes: [
                {
                    document_id: 49613,
                    unique_document_number: "49613",
                    description: null,
                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)\n \n COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30\n \n FINDINGS:\n \n BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. No definite thinning of the overlying articular cartilage is visible.\n \n TENDONS: Normal medial, posterior, lateral, and Achilles tendons. \n \n LIGAMENTS: Normal medial and lateral ligaments. Intact superior peroneal retinaculum.\n \n SOFT TISSUES: Normal muscle bulk and signal intensity.\n \n OTHER: Tarsal tunnel within normal limits. Normal fat signal within the sinus tarsi. No plantar fascia thickening.\n \n IMPRESSION:\n Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. While this most likely represents an intraosseous ganglion. The possibility of an osteochondral lesion, Brodie abscess, or even an osteoid osteoma cannot be excluded.\n \n \n \n \n \n \n \n \n \n Interpreted by:\n Daniel Ira Rosenthal, MD\n \n Signed by:\n Daniel Ira Rosenthal, MD\n 5/1/20\n \n Final result\n",
                    filename: null,
                    type: "RAW",
                    id: null
                }
            ],
            case_created_datetime: "2022-04-28 12:22:18 EDT",
            process_instance_created_datetime: "2022-04-28 12:22:18 EDT",
            exclusion_datetime: null,
            prediction_start_datetime: null,
            added_to_batch_datetime: "2022-04-28 12:25:22 EDT",
            response_from_batch_datetime: "2022-04-28 13:18:43 EDT",
            prediction_end_datetime: null,
            automation_decision_datetime: "2022-04-28 13:20:11 EDT",
            send_to_coder_datetime: null,
            received_from_coder_datetime: null,
            send_to_billing_datetime: "2022-04-28 13:21:46 EDT",
            process_instance_completed_datetime: "2022-04-28 13:21:47 EDT",
            case_completed_datetime: "2022-04-28 13:21:47 EDT",
            claims_edit_indicator: true,
            cci_edit_indicator: true,
            claims_editor_payer_id: null,
            claims_editor_payer_name: null,
            claims_editor_issues: null,
            cci_editor_issues: null,
            customer_automation_decision: null,
            post_manual_charges: true,
            prevent_billing_indicator: false,
            prevent_send_to_coder_indicator: false,
            automated_indicator: true,
            route_to_predict: true,
            route_to_billing: true,
            route_to_qa: false,
            route_to_coder: false,
            route_to_claims_editor: null,
            pre_prediction_process_reason: null,
            post_prediction_process_reason: "Automate:High Confidence Rule",
            automate_decision_reason: "RULE",
            termination_indicator: false,
            study_indicator: false,
            automation_eligible: true,
            can_automate: true,
            decoration: '{"Automate":["High Confidence Rule"]}',
            decorators: [],
            hold_billing: false,
            hold_billing_reason: null,
            release_billing_reason: null,
            release_to_billing: false,
            release_to_coder: false,
            rules: '{"Automate":[{"decoration_category":"Automate","decoration_subcategory":"High Confidence Rule","decoration_description":"Happy Path Rule"}]}',
            rule_evaluation_results: [],
            process: null,
            phase: "LIVE",
            algorithm: "feynman",
            environment: "development",
            provenance: "CmxCaseBuilder",
            ml_function: "radiology-prediction",
            ml_version: "6.0.4",
            bpm_process_id: "5ff018ab-c70f-11ec-933e-962d65ed7748",
            prediction_job_id: null,
            case_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/cases/24056.json",
            batch_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/batches/B24056.json",
            prediction_s3_uri: "s3://process-data.development.app.codametrix.com/prediction/c8bd1ac5-8686-4f13-b745-00c958d6044a/batch/1/results_unmapped/json_results/24056.json",
            external_id: "ef49dc2242a04830b180ecd140675193",
            billing_export_id: 13854,
            cac_export_id: null,
            billing_group_id: 12728,
            case_event_id: null,
            export_group_id: 3147,
            resubmit_date: null,
            submitter_process: null,
            submitted_primary_clinical_identifier: null,
            send_to_coder_orchestrator: null,
            coder_orchestrator_destination: null,
            feedback_loop_enabled: true,
            last_entity_update: "2022-04-28 17:21:47 EDT",
            rendering_provider_specialty: null,
            rendering_provider_name: "ROSENTHAL, DANIEL",
            rendering_provider_number: {
                number: "12177",
                issuer: "NWH",
                type: "PRN"
            }
        },
        {
            version: null,
            case_json_id: null,
            case_id: 20981,
            process_instance_id: 24058,
            process_instance_guid: "422dd007-f7cf-4ae1-9633-e6df0d22980a",
            case_encounter_id: 15633,
            case_status: "Automated",
            process_status: "Done",
            primary_process_indicator: false,
            run_type: "Addendum",
            source_type: "HL7",
            service_line: "Radiology",
            tenant_code: "MGH",
            tenant_name: "Massachusetts General Hospital",
            tenant_timezone: "America/New_York",
            health_system_code: "PHS",
            service_tenant_name: null,
            service_tenant_code: null,
            provider_tenant_name: null,
            provider_tenant_code: null,
            patient_id: 212060,
            patient_name: "SCENARIO14, JESSICA",
            date_of_birth: "1981-08-18",
            patient_age: null,
            patient_gender: "F",
            patient_identifier: {
                number: "8fdead1fe7bd4df7876eaeb4423e0860",
                issuer: "EPIC",
                type: "PMRN"
            },
            visit_number: {
                number: "VISIT-ad678d14026c4f8b8aa77986c69314cf",
                issuer: "EPIC",
                type: "VISIT_NUMBER"
            },
            account_number: {
                number: "6122578737",
                issuer: null,
                type: null
            },
            patient_class: "OUTPATIENT",
            patient_type: null,
            reason_for_visit: "*Ankle pain, osteochondral lesion suspected, neg xray",
            primary_insurance: null,
            primary_insurance_category: null,
            encounter_identifier: {
                number: "VISIT-ad678d14026c4f8b8aa77986c69314cf-2022-04-27-261142",
                issuer: "CMX",
                type: "ENCOUNTER_NUMBER"
            },
            point_of_care: "MGH_IMGMRNS",
            place_of_service: "MGDAN",
            order_control: "RE",
            order_number: {
                number: "RAD_PHS_CBR_001-6ab86f7da2284a6eb1a2857930115457",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_placer_number: {
                number: "RAD_PHS_CBR_001-6ab86f7da2284a6eb1a2857930115457",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_filler_number: {
                number: "Eef081057a95e43debb69ad7897ef060e",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            ordering_provider_name: "CHIODO, CHRISTOPHER",
            ordering_provider_specialty: "",
            ordering_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            primary_clinical_identifier: {
                number: "Eef081057a95e43debb69ad7897ef060e",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            division: "MGDAN",
            exam_code: "MR.MS.ANK-/R",
            exam_description: "MRI ANKLE WITHOUT CONTRAST (RIGHT)",
            body_region: "Lower Extremity",
            procedure_type: "Magnetic Resonance",
            procedure_type_category: "MR",
            work_queue_name: "MR UPPER/LOWER EXT JOINT",
            date_of_service: "2022-04-27",
            datetime_of_service: "2022-04-27 11:43:14 EDT",
            exam_date: null,
            exam_datetime: null,
            relevant_clinical_info: null,
            sending_facility: null,
            placer_field_2: null,
            patient_primary_facility: null,
            service: null,
            transaction_id: null,
            result_status: "C",
            scheduling_department: "MGH IMG MR NS",
            scheduling_department_code: "MGH_IMGMRNS",
            resource_name: "MGH MR1NS",
            resource_code: "MR1NS",
            admission_datetime: null,
            discharge_datetime: null,
            attending_provider_specialty: null,
            attending_provider_name: null,
            attending_provider_number: null,
            billing_location: "MGDAN",
            billing_area: null,
            billing_provider_specialty: "",
            billing_provider_name: "ROSENTHAL, DANIEL",
            billing_provider_number: {
                number: "12177",
                issuer: "NWH",
                type: "PRN"
            },
            billing_provider_assistant_name: null,
            billing_provider_assistant_number: null,
            billing_patient_identifier: null,
            referring_provider_specialty: null,
            referring_provider_name: "CHIODO, CHRISTOPHER",
            referring_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            performing_provider_specialty: null,
            performing_provider_name: null,
            performing_provider_number: null,
            service_provider_specialty: null,
            service_provider_name: null,
            service_provider_number: null,
            hl7_insurance_plan_id: null,
            hl7_insurance_plan_text: null,
            hl7_insurance_payer_id: null,
            hl7_insurance_payer_name: null,
            hl7_insurance_plan_type: null,
            tenant_insurance_plan_id: null,
            tenant_insurance_plan_text: null,
            tenant_insurance_payer_id: null,
            tenant_insurance_payer_name: null,
            tenant_insurance_payer_number: null,
            tenant_medicare_contractor: null,
            cmx_insurance_plan_text: null,
            cmx_insurance_payer_id: null,
            cmx_mapped_payer_number: null,
            cmx_payer_group_name_property_name: null,
            cmx_payer_category_property_name: null,
            claims_edit_enabled_indicator: null,
            medicare_jurisdiction: null,
            medicare_contractor: null,
            requires_medicaid_cci_edits_indicator: null,
            requires_cms_cci_edits_indicator: null,
            requires_ncd_edits_indicator: null,
            requires_lcd_edits_indicator: null,
            requires_commercial_edits_indicator: null,
            requires_mln_edits_indicator: null,
            requires_article_edits_indicator: null,
            requires_cms_manual_edits_indicator: null,
            requires_transmittal_manual_edits_indicator: null,
            specimen_sources: [],
            scenario: null,
            scenarios: [],
            case_type: null,
            specialty: null,
            grouper: null,
            custom_values: {
                routing: null
            },
            mappings: [
                {
                    name: "exam_code",
                    value: "MR.MS.ANK-/R",
                    mapped_values: [
                        {
                            name: "work_queue_name",
                            value: "MR UPPER/LOWER EXT JOINT",
                            values: []
                        },
                        {
                            name: "procedure_type",
                            value: "Magnetic Resonance",
                            values: []
                        },
                        {
                            name: "procedure_type_category",
                            value: "MR",
                            values: []
                        }
                    ]
                }
            ],
            invoices: [],
            artifacts: [
                {
                    artifact_id: 98536,
                    type: "MAPPED",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115031,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: -1.0,
                                    automate: false,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            modifier_uid: null,
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: -1.0,
                                            sequence_number: 1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 98537,
                    type: "CLINICAL",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115032,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: 0.0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                }
            ],
            transactions: [],
            notes: [
                {
                    document_id: 49617,
                    description: null,
                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)\n \n COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30\n \n FINDINGS:\n \n BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. No definite thinning of the overlying articular cartilage is visible.\n \n TENDONS: Normal medial, posterior, lateral, and Achilles tendons. \n \n LIGAMENTS: Normal medial and lateral ligaments. Intact superior peroneal retinaculum.\n \n SOFT TISSUES: Normal muscle bulk and signal intensity.\n \n OTHER: Tarsal tunnel within normal limits. Normal fat signal within the sinus tarsi. No plantar fascia thickening. Change in note\n \n IMPRESSION:\n Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. While this most likely represents an intraosseous ganglion. The possibility of an osteochondral lesion, Brodie abscess, or even an osteoid osteoma cannot be excluded.\n \n \n \n \n \n \n \n \n \n Interpreted by:\n Daniel Ira Rosenthal, MD\n \n Signed by:\n Daniel Ira Rosenthal, MD\n 5/1/20\n \n C result\n",
                    filename: null,
                    type: "RAW",
                    id: null
                }
            ],
            case_created_datetime: "2022-04-28 12:22:18 EDT",
            process_instance_created_datetime: "2022-04-28 12:23:06 EDT",
            exclusion_datetime: "2022-04-28 13:26:24 EDT",
            prediction_start_datetime: null,
            added_to_batch_datetime: null,
            response_from_batch_datetime: null,
            prediction_end_datetime: null,
            automation_decision_datetime: "2022-04-28 13:26:24 EDT",
            send_to_coder_datetime: null,
            received_from_coder_datetime: null,
            send_to_billing_datetime: null,
            process_instance_completed_datetime: "2022-04-28 13:26:25 EDT",
            case_completed_datetime: "2022-04-28 13:26:25 EDT",
            claims_edit_indicator: null,
            cci_edit_indicator: null,
            claims_editor_payer_id: null,
            claims_editor_payer_name: null,
            claims_editor_issues: null,
            cci_editor_issues: null,
            customer_automation_decision: null,
            post_manual_charges: true,
            prevent_billing_indicator: false,
            prevent_send_to_coder_indicator: false,
            automated_indicator: false,
            route_to_predict: false,
            route_to_billing: false,
            route_to_qa: false,
            route_to_coder: false,
            route_to_claims_editor: null,
            pre_prediction_process_reason: "Customer:Amendment",
            post_prediction_process_reason: null,
            automate_decision_reason: null,
            termination_indicator: true,
            study_indicator: false,
            automation_eligible: false,
            can_automate: false,
            decoration: '{"Customer":["Addendum","Amendment"]}',
            decorators: [],
            hold_billing: false,
            hold_billing_reason: null,
            release_billing_reason: null,
            release_to_billing: true,
            release_to_coder: false,
            rules: '{"Customer":[{"decoration_category":"Customer","decoration_subcategory":"Addendum","decoration_description":"Default Addendum"},{"decoration_category":"Customer","decoration_subcategory":"Amendment","decoration_description":"Amendment"}]}',
            rule_evaluation_results: [],
            process: null,
            phase: "LIVE",
            algorithm: "feynman",
            environment: null,
            provenance: null,
            ml_function: "radiology-prediction",
            ml_version: "6.0.4",
            bpm_process_id: "7c455cf9-c70f-11ec-933e-962d65ed7748",
            prediction_job_id: null,
            case_s3_uri: null,
            batch_s3_uri: null,
            prediction_s3_uri: null,
            external_id: "61b0183bd4c6409e94c873269e2e9b30",
            billing_export_id: null,
            cac_export_id: null,
            billing_group_id: null,
            case_event_id: null,
            export_group_id: null,
            resubmit_date: null,
            submitter_process: null,
            submitted_primary_clinical_identifier: null,
            send_to_coder_orchestrator: null,
            coder_orchestrator_destination: null,
            feedback_loop_enabled: true,
            last_entity_update: "2022-04-28 17:26:25 EDT",
            rendering_provider_specialty: null,
            rendering_provider_name: "ROSENTHAL, DANIEL",
            rendering_provider_number: {
                number: "12177",
                issuer: "NWH",
                type: "PRN"
            }
        },
        {
            version: null,
            case_json_id: null,
            case_id: 20981,
            process_instance_id: 24057,
            process_instance_guid: "6580414c-8b24-4a40-8aea-a426a6b7f575",
            case_encounter_id: 15633,
            case_status: "Automated",
            process_status: "Done",
            primary_process_indicator: false,
            run_type: "Addendum",
            source_type: "HL7",
            service_line: "Radiology",
            tenant_code: "MGH",
            tenant_name: "Massachusetts General Hospital",
            tenant_timezone: "America/New_York",
            health_system_code: "PHS",
            service_tenant_name: null,
            service_tenant_code: null,
            provider_tenant_name: null,
            provider_tenant_code: null,
            patient_id: 212060,
            patient_name: "SCENARIO14, JESSICA",
            date_of_birth: "1981-08-18",
            patient_age: null,
            patient_gender: "F",
            patient_identifier: {
                number: "8fdead1fe7bd4df7876eaeb4423e0860",
                issuer: "EPIC",
                type: "PMRN"
            },
            visit_number: {
                number: "VISIT-ad678d14026c4f8b8aa77986c69314cf",
                issuer: "EPIC",
                type: "VISIT_NUMBER"
            },
            account_number: {
                number: "6122578737",
                issuer: null,
                type: null
            },
            patient_class: "OUTPATIENT",
            patient_type: null,
            reason_for_visit: "*Ankle pain, osteochondral lesion suspected, neg xray",
            primary_insurance: null,
            primary_insurance_category: null,
            encounter_identifier: {
                number: "VISIT-ad678d14026c4f8b8aa77986c69314cf-2022-04-27-261142",
                issuer: "CMX",
                type: "ENCOUNTER_NUMBER"
            },
            point_of_care: "MGH_IMGMRNS",
            place_of_service: "MGDAN",
            order_control: "RE",
            order_number: {
                number: "RAD_PHS_CBR_001-6ab86f7da2284a6eb1a2857930115457",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_placer_number: {
                number: "RAD_PHS_CBR_001-6ab86f7da2284a6eb1a2857930115457",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_filler_number: {
                number: "Eef081057a95e43debb69ad7897ef060e",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            ordering_provider_name: "CHIODO, CHRISTOPHER",
            ordering_provider_specialty: "",
            ordering_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            primary_clinical_identifier: {
                number: "Eef081057a95e43debb69ad7897ef060e",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            division: "MGDAN",
            exam_code: "MR.MS.ANK-/R",
            exam_description: "MRI ANKLE WITHOUT CONTRAST (RIGHT)",
            body_region: "Lower Extremity",
            procedure_type: "Magnetic Resonance",
            procedure_type_category: "MR",
            work_queue_name: "MR UPPER/LOWER EXT JOINT",
            date_of_service: "2022-04-27",
            datetime_of_service: "2022-04-27 11:43:14 EDT",
            exam_date: null,
            exam_datetime: null,
            relevant_clinical_info: null,
            sending_facility: null,
            placer_field_2: null,
            patient_primary_facility: null,
            service: null,
            transaction_id: null,
            result_status: "C",
            scheduling_department: "MGH IMG MR NS",
            scheduling_department_code: "MGH_IMGMRNS",
            resource_name: "MGH MR1NS",
            resource_code: "MR1NS",
            admission_datetime: null,
            discharge_datetime: null,
            attending_provider_specialty: null,
            attending_provider_name: null,
            attending_provider_number: null,
            billing_location: "MGDAN",
            billing_area: null,
            billing_provider_specialty: "",
            billing_provider_name: "ROSENTHAL, DANIEL",
            billing_provider_number: {
                number: "12177",
                issuer: "NWH",
                type: "PRN"
            },
            billing_provider_assistant_name: null,
            billing_provider_assistant_number: null,
            billing_patient_identifier: null,
            referring_provider_specialty: null,
            referring_provider_name: "CHIODO, CHRISTOPHER",
            referring_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            performing_provider_specialty: null,
            performing_provider_name: null,
            performing_provider_number: null,
            service_provider_specialty: null,
            service_provider_name: null,
            service_provider_number: null,
            hl7_insurance_plan_id: null,
            hl7_insurance_plan_text: null,
            hl7_insurance_payer_id: null,
            hl7_insurance_payer_name: null,
            hl7_insurance_plan_type: null,
            tenant_insurance_plan_id: null,
            tenant_insurance_plan_text: null,
            tenant_insurance_payer_id: null,
            tenant_insurance_payer_name: null,
            tenant_insurance_payer_number: null,
            tenant_medicare_contractor: null,
            cmx_insurance_plan_text: null,
            cmx_insurance_payer_id: null,
            cmx_mapped_payer_number: null,
            cmx_payer_group_name_property_name: null,
            cmx_payer_category_property_name: null,
            claims_edit_enabled_indicator: null,
            medicare_jurisdiction: null,
            medicare_contractor: null,
            requires_medicaid_cci_edits_indicator: null,
            requires_cms_cci_edits_indicator: null,
            requires_ncd_edits_indicator: null,
            requires_lcd_edits_indicator: null,
            requires_commercial_edits_indicator: null,
            requires_mln_edits_indicator: null,
            requires_article_edits_indicator: null,
            requires_cms_manual_edits_indicator: null,
            requires_transmittal_manual_edits_indicator: null,
            specimen_sources: [],
            scenario: null,
            scenarios: [],
            case_type: null,
            specialty: null,
            grouper: null,
            custom_values: {
                routing: null
            },
            mappings: [
                {
                    name: "exam_code",
                    value: "MR.MS.ANK-/R",
                    mapped_values: [
                        {
                            name: "work_queue_name",
                            value: "MR UPPER/LOWER EXT JOINT",
                            values: []
                        },
                        {
                            name: "procedure_type",
                            value: "Magnetic Resonance",
                            values: []
                        },
                        {
                            name: "procedure_type_category",
                            value: "MR",
                            values: []
                        }
                    ]
                }
            ],
            invoices: [],
            artifacts: [
                {
                    artifact_id: 98534,
                    type: "MAPPED",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115029,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: -1.0,
                                    automate: false,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            modifier_uid: null,
                                            evidence_source_uid: null,
                                            automate: false,
                                            confidence: -1.0,
                                            sequence_number: 1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 98535,
                    type: "CLINICAL",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 115030,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true,
                                modifiers: {
                                    confidence: 0.0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                }
            ],
            transactions: [],
            notes: [
                {
                    document_id: 49615,
                    description: null,
                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)\n \n COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30\n \n FINDINGS:\n \n BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. No definite thinning of the overlying articular cartilage is visible.\n \n TENDONS: Normal medial, posterior, lateral, and Achilles tendons. \n \n LIGAMENTS: Normal medial and lateral ligaments. Intact superior peroneal retinaculum.\n \n SOFT TISSUES: Normal muscle bulk and signal intensity.\n \n OTHER: Tarsal tunnel within normal limits. Normal fat signal within the sinus tarsi. No plantar fascia thickening. Change in note\n \n IMPRESSION:\n Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. While this most likely represents an intraosseous ganglion. The possibility of an osteochondral lesion, Brodie abscess, or even an osteoid osteoma cannot be excluded.\n \n \n \n \n \n \n \n \n \n Interpreted by:\n Daniel Ira Rosenthal, MD\n \n Signed by:\n Daniel Ira Rosenthal, MD\n 5/1/20\n \n C result\n",
                    filename: null,
                    type: "RAW",
                    id: null
                }
            ],
            case_created_datetime: "2022-04-28 12:22:18 EDT",
            process_instance_created_datetime: "2022-04-28 12:22:45 EDT",
            exclusion_datetime: "2022-04-28 13:24:14 EDT",
            prediction_start_datetime: null,
            added_to_batch_datetime: null,
            response_from_batch_datetime: null,
            prediction_end_datetime: null,
            automation_decision_datetime: "2022-04-28 13:24:14 EDT",
            send_to_coder_datetime: null,
            received_from_coder_datetime: null,
            send_to_billing_datetime: null,
            process_instance_completed_datetime: "2022-04-28 13:24:15 EDT",
            case_completed_datetime: "2022-04-28 13:24:15 EDT",
            claims_edit_indicator: null,
            cci_edit_indicator: null,
            claims_editor_payer_id: null,
            claims_editor_payer_name: null,
            claims_editor_issues: null,
            cci_editor_issues: null,
            customer_automation_decision: null,
            post_manual_charges: true,
            prevent_billing_indicator: false,
            prevent_send_to_coder_indicator: false,
            automated_indicator: false,
            route_to_predict: false,
            route_to_billing: false,
            route_to_qa: false,
            route_to_coder: false,
            route_to_claims_editor: null,
            pre_prediction_process_reason: "Customer:Amendment",
            post_prediction_process_reason: null,
            automate_decision_reason: null,
            termination_indicator: true,
            study_indicator: false,
            automation_eligible: false,
            can_automate: false,
            decoration: '{"Customer":["Addendum","Amendment"]}',
            decorators: [],
            hold_billing: false,
            hold_billing_reason: null,
            release_billing_reason: null,
            release_to_billing: true,
            release_to_coder: false,
            rules: '{"Customer":[{"decoration_category":"Customer","decoration_subcategory":"Addendum","decoration_description":"Default Addendum"},{"decoration_category":"Customer","decoration_subcategory":"Amendment","decoration_description":"Amendment"}]}',
            rule_evaluation_results: [],
            process: null,
            phase: "LIVE",
            algorithm: "feynman",
            environment: null,
            provenance: null,
            ml_function: "radiology-prediction",
            ml_version: "6.0.4",
            bpm_process_id: "6fda31ae-c70f-11ec-933e-962d65ed7748",
            prediction_job_id: null,
            case_s3_uri: null,
            batch_s3_uri: null,
            prediction_s3_uri: null,
            external_id: "64716c7cad01454da93b7358c057b2c2",
            billing_export_id: null,
            cac_export_id: null,
            billing_group_id: null,
            case_event_id: null,
            export_group_id: null,
            resubmit_date: null,
            submitter_process: null,
            submitted_primary_clinical_identifier: null,
            send_to_coder_orchestrator: null,
            coder_orchestrator_destination: null,
            feedback_loop_enabled: true,
            last_entity_update: "2022-04-28 17:24:15 EDT",
            rendering_provider_specialty: null,
            rendering_provider_name: "ROSENTHAL, DANIEL",
            rendering_provider_number: {
                number: "12177",
                issuer: "NWH",
                type: "PRN"
            }
        }
    ]
};
//# sourceMappingURL=multiple-addendum.js.map